// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question_pattern a,
.question_pattern a:hover {
  text-decoration: none;
}
.question_pattern .icon_block img {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}`, "",{"version":3,"sources":["webpack://./src/neetjee_guru/components/questioners/question_pattern/_questionpattern.scss"],"names":[],"mappings":"AAEI;;EAEI,qBAAA;AADR;AAII;EACI,mDAAA;AAFR","sourcesContent":[".question_pattern {\n\n    a,\n    a:hover {\n        text-decoration: none;\n    }\n\n    .icon_block img {\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
